module.exports = __webpack_public_path__ + "static/media/pisos-vinilicos.7dcb6a9a.jpg";